import {
  OpenMarketProductApporovalStatusType,
  WheelConditionLevel,
} from '../../../constants/openMarketProduct/openMarketProduct';
import { ProductStatusType } from '../../../constants/product/product.constant';
import { customAxios } from '../../common/customAxios';
import { ITractorImage } from './postUsersSellTractors';

export interface IUserSellTractorsReqBody {
  manufacturedYear?: number;
  operationTime?: number;
  option?: string | null;
  optionDetails?: string[] | null;
  workingMachine?: string | null;
  workingMachineDetails?: string[] | null;
  hopeSellingPrice?: number;
  tractorImages?: ITractorImage[];
  location?: string;
  directImportYn?: boolean | null;
  priceNegotiationYn?: boolean | null;
  frontTireCondition?: WheelConditionLevel | null;
  rearTireCondition?: WheelConditionLevel | null;
  leftTrackCondition?: WheelConditionLevel | null;
  rightTrackCondition?: WheelConditionLevel | null;
  frontWheelCondition?: WheelConditionLevel | null;
  rearWheelCondition?: WheelConditionLevel | null;
  needRepairParts?: string[] | null;
  replacedParts?: string[] | null;
  information?: string;
  approvalStatus: OpenMarketProductApporovalStatusType;
  status: ProductStatusType;
}

interface patchUserSellTractorsParams {
  sellTractorId: string;
  reqBody: IUserSellTractorsReqBody;
}

export const patchUserSellTractors = ({ sellTractorId, reqBody }: patchUserSellTractorsParams): Promise<void> => {
  return customAxios.patch(`/user-sell-tractors/mine/${sellTractorId}`, reqBody);
};
